__turbopack_context__.v({
  "navigationLink": "styles-module___M96lW__navigationLink",
  "navigationLink--active": "styles-module___M96lW__navigationLink--active",
});
